import "./index.scss";

export default function LoadingSpinner() {
  return <div className="loading" />;
}
